export default __webpack_public_path__ + "static/media/Group1174.d0406ba3.svg";